export const DEPARTMENTS = [
  { value: 'الإدارة العامة', label_ar: 'الإدارة العامة', label_en: 'General Administration', subs: [
    { value: 'الجودة', label_ar: 'الجودة', label_en: 'Quality' },
    { value: 'المالية', label_ar: 'المالية', label_en: 'Finance' },
    { value: 'شؤون الموظفين', label_ar: 'شؤون الموظفين', label_en: 'HR' },
    { value: 'تقنية المعلومات', label_ar: 'تقنية المعلومات', label_en: 'IT' },
    { value: 'الصيانة', label_ar: 'إدارة المرافق والتشغيل', label_en: 'Facilities & Operations Management' },
  ]},
  { value: 'الإدارة الطبية', label_ar: 'الإدارة الطبية', label_en: 'Medical Administration', subs: [
    { value: 'الأطباء', label_ar: 'الأطباء', label_en: 'Doctors' },
    { value: 'التمريض', label_ar: 'التمريض', label_en: 'Nursing' },
  ] },
  { value: 'طب الأسنان', label_ar: 'طب الأسنان', label_en: 'Dentistry', subs: [
    { value: 'أطباء الأسنان', label_ar: 'أطباء الأسنان', label_en: 'Dentists' },
    { value: 'مساعدي الأطباء', label_ar: 'مساعدي الأطباء', label_en: 'Dental Assistants' },
  ] },
  { value: 'المعمل', label_ar: 'المعمل', label_en: 'Laboratory', subs: [] },
  { value: 'التعقيم', label_ar: 'التعقيم', label_en: 'Sterilization', subs: [] },
  { value: 'خدمة العملاء', label_ar: 'خدمة العملاء', label_en: 'Customer Service', subs: [] },
  { value: 'التأمين', label_ar: 'التأمين', label_en: 'Insurance', subs: [] },
];

export const getDeptLabel = (deptValue, lang) => {
  if (!deptValue) return '-';
  const dept = DEPARTMENTS.find(d => d.value === deptValue);
  if (!dept) return deptValue;
  return lang === 'en' ? dept.label_en : dept.label_ar;
};

export const getSubDeptLabel = (deptValue, subValue, lang) => {
  if (!subValue) return '';
  const dept = DEPARTMENTS.find(d => d.value === deptValue);
  if (!dept) return subValue;
  const sub = dept.subs?.find(s => s.value === subValue);
  if (!sub) return subValue;
  return lang === 'en' ? sub.label_en : sub.label_ar;
};
